<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><span><i>For Linda Halcott Lee,</i></span></p>
<p class="ded1"><span><i>A Good Friend</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?aa3608c0